import SpecSheetDeleteDialog from "./SpecSheetDeleteDialog";
import {
	Crudable,
	FetchesData
} from "kinnect-mixins";
import {
	KDataTable,
	KDataTableMenu,
	KLink
} from "kinnect-general";
import { SpecSheet } from "kinnect-models";
import {
	VIcon,
	VList,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemTitle
} from "vuetify/lib";
import { removeByObjectValue } from "kinnect-helpers";

export default KDataTable.extend( {
	name: "SpecSheetsTable",

	mixins: [
		Crudable,
		FetchesData
	],

	props: {
		noDataText: {
			...KDataTable.options.props.noDataText,
			default: "There are no spec sheets to display"
		},

		noResultsText: {
			...KDataTable.options.props.noResultsText,
			default: "No matching spec sheets found"
		},

		sortBy: {
			...KDataTable.options.props.sortBy,
			default: "manufacturerName"
		}
	},

	data: () => ( {
		items: [],
		crud: "spec_sheets"
	} ),

	computed: {
		defaultHeaders() {
			return [
				{
					sortable: false,
					text: "File",
					value: "fileUrl"
				},
				{
					text: "Manufacturer",
					value: "manufacturerName"
				},
				{
					text: "Product Name",
					value: "productName"
				},
				{
					text: "Model Number",
					value: "modelNumber"
				},
				{
					text: "Part Number",
					value: "partNumber"
				},
				{
					text: "Description",
					value: "description"
				},
				{
					align: "end",
					sortable: false,
					text: this.isMobile ? "Actions" : "",
					value: "actions"
				}
			];
		}
	},

	methods: {
		deleteItem( item ) {
			return item.delete().then( () => {
				this.items = removeByObjectValue( this.items, "id", item.id );
			} );
		},

		async fetchItems() {
			this.items = await SpecSheet.get();
		},

		async fetch() {
			await this.fetchItems();
		}
	},

	render() {
		return <KDataTable
			attrs={this.$props}
			headers={this.$_headers}
			items={this.items}
			loading={this.$wait.is( "get spec sheets" )}
			on={{ ...this.$listeners }}
			scopedSlots={{
				"item.fileUrl": ( { item } ) =>
					<KLink
						href={item.fileUrl}
						icon="attach_file"
						target="_blank"
					>Spec Sheet</KLink>,

				"item.actions": ( { item } ) =>
					<KDataTableMenu>
						<VList>
							<VListItem to={{
								name: "specSheet",
								params: { idSpecSheet: item.id }
							}}>
								<VListItemAction>
									<VIcon>visibility</VIcon>
								</VListItemAction>

								<VListItemContent>
									<VListItemTitle>View</VListItemTitle>
								</VListItemContent>
							</VListItem>

							{this.canDelete && <SpecSheetDeleteDialog
								item={item}
								onConfirm={() => this.deleteItem( item )}
								scopedSlots={{
									activator: ( { on } ) =>
										<VListItem on={on}>
											<VListItemAction>
												<VIcon>delete</VIcon>
											</VListItemAction>

											<VListItemContent>
												<VListItemTitle>Delete</VListItemTitle>
											</VListItemContent>
										</VListItem>
								}}
							></SpecSheetDeleteDialog>}
						</VList>
					</KDataTableMenu>,

				...this.$scopedSlots
			}}
		></KDataTable>;
	},

	beforeCreate() {
		delete this.$options.props.items;
		delete this.$options.props.loading;
	}
} );
